import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AmountUtils, cn, PaletteUtils } from '@shared/utils';
import type { AccountResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface AccountProgressProps {
  className?: string;
  account: AccountResponse;
}

export const AccountProgress = (props: AccountProgressProps) => {
  const { t } = useTranslation('accounts');

  const progress = useMemo(() => {
    if (props.account.balance) return props.account.balance / (props.account.creditLimit ?? 0 / 100);
    return 0;
  }, [props.account]);
  return (
    <div className={cn('flex flex-col gap-2', props.className)}>
      <div className='relative h-1 w-full rounded bg-light'>
        <div
          className={cn('absolute left-0 h-full rounded bg-primary', PaletteUtils.isVcfcPalette && 'dark:bg-white')}
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className='flex justify-between'>
        <Text size='sm' color='secondary'>
          {t('card.tile.fields.spendingLimit')}
        </Text>
        <Text weight='medium' size='xs'>
          {`${AmountUtils.transformToAmountWithCurrency(props.account.balance, props.account.currency)} / ${AmountUtils.transformToAmountWithCurrency(props.account.creditLimit, props.account.currency)}`}
        </Text>
      </div>
    </div>
  );
};
